// Module
var code = "<svg width=\"18\" height=\"18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14.657 3.343A8 8 0 1 1 3.343 14.657 8 8 0 0 1 14.657 3.343M6.36 9.263h5.359M9.039 11.942V6.583\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg> ";
// Exports
module.exports = code;